<div class="p-6 w-full max-w-md">
    <div class="flex flex-col items-center gap-4 p-6 bg-[#0097ac] text-white rounded-lg">
     <mat-icon class="customIconSize">system_update</mat-icon>
      <h1 class="text-xl font-bold ">New Version Available</h1>
    </div>
    <div class="flex flex-col gap-4 my-6">
      <h2 class="text-xl font-bold space-y-4">Recomendations</h2>
      <ul>
        <li>Press CTRL + F5</li>
        <li>Close all the open tabs</li>
        <li>Log out</li>
      </ul>
    </div>
    <div class ="flex justify-end gap-4 pt-4">
      <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" class="update-button" (click)="onConfirm()">Update</button>
    </div>
  </div>